import { SET_FILTER_PARAMS } from './../const';

export default (filterParams) => {
    return {type: SET_FILTER_PARAMS, filterParams}
};
